import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';
import './App.css';
import DisplayBoard from './components/DisplayBoard';
import TicketDisplay from './components/TicketDisplay';
import Admin from './components/Admin';
import CookieNotice from './components/CookieNotice';

// API URL - prázdný string pro produkci (relativní cesta), localhost pro vývoj
const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001');

function TicketPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const searchParams = new URLSearchParams(window.location.search);
  const isNew = searchParams.get('new') === 'true';

  useEffect(() => {
    const fetchTicket = async () => {
      try {
        const response = await fetch(`${API_URL}/api/tickets/${id}`);
        if (response.ok) {
          const data = await response.json();
          setTicket(data);
        } else {
          console.error('Ticket not found');
          navigate('/');
        }
      } catch (error) {
        console.error('Error loading ticket:', error);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };
    fetchTicket();
  }, [id, navigate]);

  if (loading) {
    return <div>Načítání...</div>;
  }

  return ticket ? (
    <TicketDisplay
      ticket={ticket}
      onBack={() => navigate('/')}
      isNewTicket={isNew}
      hideBackButton={true}
    />
  ) : null;
}

function BoardPage() {
  const [tickets, setTickets] = useState([]);
  const [totalTickets, setTotalTickets] = useState(0);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isNewTicket, setIsNewTicket] = useState(false);

  useEffect(() => {
    fetchTickets();
    fetchTotalTickets();
    const interval = setInterval(() => {
      fetchTickets();
      fetchTotalTickets();
    }, 10000); // Refresh každých 10s
    return () => clearInterval(interval);
  }, []);

  const fetchTickets = async () => {
    try {
      const response = await fetch(`${API_URL}/api/tickets/recent?limit=12&customOnly=true`);
      const data = await response.json();
      setTickets(data);
    } catch (error) {
      console.error('Chyba při načítání lístků:', error);
    }
  };

  const fetchTotalTickets = async () => {
    try {
      const response = await fetch(`${API_URL}/api/tickets/count`);
      const data = await response.json();
      setTotalTickets(data.count);
    } catch (error) {
      console.error('Chyba při načítání celkového počtu lístků:', error);
    }
  };

  const handleNewRequest = async (request) => {
    try {
      const response = await fetch(`${API_URL}/api/tickets`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request }),
      });
      const newTicket = await response.json();
      setSelectedTicket(newTicket);
      setIsNewTicket(true);
    } catch (error) {
      console.error('Chyba při vytváření lístku:', error);
      alert('Nepodařilo se vytvořit lístek. Zkuste to prosím znovu.');
    }
  };

  const handleTicketClick = (ticket) => {
    setSelectedTicket(ticket);
    setIsNewTicket(false);
  };

  const handleCloseModal = () => {
    setSelectedTicket(null);
    setIsNewTicket(false);
  };

  return (
    <>
      <DisplayBoard
        tickets={tickets}
        totalTickets={totalTickets}
        onNewRequest={handleNewRequest}
        onTicketClick={handleTicketClick}
        onModalClose={handleCloseModal}
      />
      {selectedTicket && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <TicketDisplay
              ticket={selectedTicket}
              onBack={handleCloseModal}
              isNewTicket={isNewTicket}
              hideBackButton={true}
              showCloseButton={true}
              onClose={handleCloseModal}
            />
          </div>
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<BoardPage />} />
        <Route path="/ticket/:id" element={<TicketPage />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <CookieNotice />
    </div>
  );
}

export default App;
